module.exports = __webpack_public_path__ + "static/img/exam-type04.f958871a.png";